import { useLazyQuery } from '@apollo/client';

import GetHistoryAuditQuery from '@/graphql/contracts/getHistoryAudit.query.gql';
import { GetHistoryAudit, GetHistoryAuditVariables } from '@/graphql/contracts/_generated_/getHistoryAudit.query';
import { notificationService } from '@/services/notification/notification.client';
import { EntityTypeEnum } from '@/graphql/contracts/_generated_/contracts';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

export function useGetProductsHistory() {
  const [_getProductsHistory, { data, loading }] = useLazyQuery<
  GetHistoryAudit,
  GetHistoryAuditVariables
  >(GetHistoryAuditQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) => {
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      });
    },
  });

  const getProductsHistory = (productId: string) => {
    _getProductsHistory({
      variables: {
        entityId: productId,
        entityType: EntityTypeEnum.PRODUCT,
      },
    });
  };

  return {
    getProductsHistory,
    productsHistory: data?.history,
    isLoading: loading,
  };
}
